import { KeycloakContextProps } from '@shared/types/keycloakTypes';
import { createContext } from 'react';

export const KeycloakContext = createContext<KeycloakContextProps>({
  keycloak: undefined,
  authenticated: false,
  userInfo: null,
});
